// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zAcEF","label":"styles_label__3aDN8"};